<template>
  <div class="c-plan g-container">
    <Breadcrumb class="m-bread">
      <BreadcrumbItem> <Icon type="ios-home-outline"></Icon> 选择投放账号 </BreadcrumbItem>
      <BreadcrumbItem> <Icon type="logo-buffer"></Icon> 设置计划 </BreadcrumbItem>
    </Breadcrumb>

    <!-- 滚动区域 -->
    <div class="module-content" ref="container">
      <moduler v-for="item in subModules" :key="item.id" :title="item.name" :name="item.href">
        <!-- 基础信息 -->
        <template v-if="item.href === 'plan_basic'">
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field row-item-must">计划组名称</span>
            </Col>
            <Col span="18">
              <input-len
                ref="planinput"
                v-model="plan.plan_name"
                placeholder="最大80个字符，1个中文等于2个字符"
                width="480"
                :max="80"
                :dyn-pos="dynpos"
                @on-del-trend="validTrend"
                @on-focus="focusPlan"
                @on-blur="blurPlan"
                @change="validTrend"
              />
              <span style="margin-left: 12px" v-if="check">
                <Icon type="ios-loading" color="#5cadff" size="18" v-if="check === 'loading'" />
                <Icon type="md-checkmark" color="#19be6b" size="18" v-if="check === 'success'" />
                <Icon type="md-close" color="#ed4014" size="18" v-if="check === 'error'" />
                <span v-if="check === 'success'">标题可用</span>
                <span v-if="check === 'error'">此标题已被占用，请换一个！</span>
              </span>
              <dd class="dynamic-error g-error-text" v-html="dynErr"></dd>
              <ul class="m-dynamic">
                <span>插入动态名称:</span>
                <li v-for="(word, i) in dynwords" :key="i">
                  <a href="javascript:;" @click.stop="appendTrend(word)">+{{ word }}</a>
                </li>
              </ul>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field row-item-must">游戏平台</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="plan.ch_platform_id" @on-change="platformChange" type="button">
                <Radio :label="1" :disabled="editState || isMiniGame">Android</Radio>
                <Radio :label="2" :disabled="editState || isMiniGame">iOS</Radio>
                <Radio :label="3" :disabled="editState" v-if="isLink">微信小程序</Radio>
                <Radio :label="3" :disabled="editState" v-if="isMiniGame">微信小程序</Radio>
              </RadioGroup>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field row-item-must">投放游戏</span>
            </Col>
            <Col span="12">
              <auto-complete
                :data="platformGameData"
                v-model="plan.game_id"
                placeholder="请选择推广游戏"
                :width="358"
                :disabled="editState"
                @on-select="handleGame"
              ></auto-complete>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">是否代投</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="plan.agent" type="button" @on-change="changeAgent">
                <Radio label="NOAGENT" :disabled="editState">非代投</Radio>
                <Radio label="AGENT" :disabled="editState">代投</Radio>
              </RadioGroup>
            </Col>
          </Row>
          <Row v-if="plan.agent === 'AGENT'" class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field row-item-must">代投账号</span>
            </Col>
            <Col span="12">
              <auto-complete
                :data="agentData"
                v-model="plan.proxy_account_id"
                placeholder="请选择代投账号"
                :disabled="editState"
                @on-select="handleAgent"
              ></auto-complete>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">投放方式</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="plan.landing_type" type="button">
                <Radio label="APP" :disabled="editState || isLink || isMiniGame">APP应用</Radio>
                <Radio label="LINK" :disabled="editState || isAndroid || isIOS">落地页</Radio>
              </RadioGroup>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">智能自动化</span>
            </Col>
            <Col span="12">
              <select-monitor :data="plan.managePlan" :media="media" :open-id="opId" @on-delete="delMonitor" @on-select="appendButler" />
            </Col>
          </Row>

          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">回调开关</span>
            </Col>
            <Col span="12" class="col-flex">
              <i-Switch v-model="plan.callback_switch" :disabled="editState || isIOS || isMiniGame" :true-value="1" :false-value="0" />
              <span v-if="isIOS" style="color: #ff0000; margin-left: 1em">iOS请务必选择需要的回调类型</span>
              <span v-if="isMiniGame" style="color: #ff0000; margin-left: 1em">微信小程序必须要打开需要的回调类型</span>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12" v-if="plan.callback_switch">
            <Col span="3" class="col-item">
              <span class="item-field">回调类型</span>
            </Col>
            <Col span="12" class="col-flex">
              <CheckboxGroup v-model="plan.callback_settings">
                <Checkbox label="callbackTypeActive" disabled>激活</Checkbox>
                <Checkbox label="callbackTypeRegist">注册</Checkbox>
                <Checkbox label="callbackTypeRecharge">付费</Checkbox>
                <Checkbox label="callbackTypeMoney">订单金额</Checkbox>
              </CheckboxGroup>
            </Col>
          </Row>
        </template>

        <!-- 投放目标 -->
        <template v-if="item.href === 'plan_target'">
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">计划投放位置</span>
            </Col>
            <Col span="12">
              <Mixcheck v-model="plan.union" @on-change="changeUnion">
                <radio-item :label="0" :disabled="editState">默认</radio-item>
                <radio-item :label="1" :disabled="editState">快手计划联盟</radio-item>
              </Mixcheck>
            </Col>
          </Row>
          <template v-if="isLink || isMiniGame">
            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field">投放类型</span>
              </Col>
              <Col span="12">
                <RadioGroup v-model="plan.promoted_type" type="button" @on-change="onPromotedChange">
                  <Radio :label="0">常规落地页</Radio>
                  <!-- 小程序不能进行预约投放 -->
                  <Radio :label="1" :disabled="plan.ch_platform_id === 3">预约投放</Radio>
                </RadioGroup>
              </Col>
            </Row>

            <template v-if="plan.promoted_type === 1">
              <Row class="row-item" :gutter="12">
                <Col span="3" class="col-item">
                  <span class="item-field">预约落地页</span>
                </Col>
                <Col span="12">
                  <RadioGroup v-model="plan.site_type" type="button">
                    <Radio :label="1">IOS预约</Radio>
                    <Radio :label="2">安卓预约</Radio>
                  </RadioGroup>
                </Col>
              </Row>

              <Row class="row-item" :gutter="12">
                <Col span="3" class="col-item">
                  <span class="item-field"></span>
                </Col>
                <Col span="12">
                  <Select v-model="plan.site_id" style="width: 220px" placeholder="请选择预约落地页">
                    <Option v-for="item in landPageList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                  </Select>
                </Col>
              </Row>
            </template>

            <template v-if="plan.promoted_type === 0">
              <Row class="row-item" :gutter="12">
                <Col span="3" class="col-item">
                  <span class="item-field row-item-must">推广落地页</span>
                </Col>
                <Col span="12">
                  <RadioGroup v-model="plan.page_type_custom" type="button">
                    <Radio :label="1" :disabled="editState">快手建站落地页</Radio>
                    <Radio :label="2" :disabled="editState || isMiniGame">平头哥落地页</Radio>
                  </RadioGroup>
                </Col>
              </Row>
              <Row class="row-item" :gutter="12" v-if="plan.page_type_custom === 1">
                <Col span="3" class="col-item">
                  <span class="item-field"></span>
                </Col>
                <Col span="12">
                  <page-select @on-select="pageModal = true" :urls="plan.externalUrls" :type="pageType"> </page-select>
                </Col>
              </Row>
              <Row class="row-item" :gutter="12" v-if="plan.page_type_custom === 2">
                <Col span="3" class="col-item">
                  <span class="item-field"></span>
                </Col>
                <Col span="12">
                  <Button type="primary" @click="linkModel = true">选择平头哥落地页</Button>
                  <span v-if="plan.land_page_id" style="margin-left: 20px">
                    已选落地页ID：<span style="color: red">{{ plan.land_page_id }}</span>
                  </span>
                </Col>
              </Row>
            </template>
          </template>
          <template v-else>
            <Row class="row-item" :gutter="12" v-if="isAndroid">
              <Col span="3" class="col-item">
                <span class="item-field">应用类型</span>
              </Col>
              <Col span="12">
                <Select v-model="plan.app_type" placeholder="请选择应用类型" style="width: 398px">
                  <Option value="android" :disabled="editState">Android应用下载</Option>
                </Select>
              </Col>
            </Row>

            <Row class="row-item" :gutter="12" v-if="isAndroid">
              <Col span="3" class="col-item">
                <span class="item-field row-item-must">应用名称</span>
              </Col>
              <Col span="12">
                <input-len v-model="plan.app_name" placeholder="最大100个字符，1个中文等于2个字符" width="398" :max="100" />
                <p style="color: #ff0000; margin-bottom: 0; margin-top: 1em">
                  注意：该处的名字对应的是媒体后台应用名称，有多余的文字请记得手动删除掉
                </p>
              </Col>
            </Row>

            <Row class="row-item" :gutter="12" v-if="isAndroid">
              <Col span="3" class="col-item">
                <span class="item-field">应用包名</span>
              </Col>
              <Col span="12">
                <Input v-model="plan.package" placeholder="应用包名根据选择游戏自动获取" style="width: 398px" disabled />
              </Col>
            </Row>

            <Row class="row-item" :gutter="12" v-if="isAndroid">
              <Col span="3" class="col-item">
                <span class="item-field">应用图标</span>
              </Col>
              <Col span="12">
                <img v-if="plan.app_icon" :src="plan.app_icon" width="64px" height="64px" />
                <div v-else style="background-color: #ccc; border-radius: 4px; width: 64px; height: 64px"></div>
              </Col>
            </Row>

            <Row class="row-item" :gutter="12" v-if="isAndroid">
              <Col span="3" class="col-item">
                <span class="item-field">是否接入快手SDK</span>
              </Col>
              <Col span="12" class="col-flex">
                <i-Switch v-model="plan.use_sdk" :true-value="1" :false-value="0" />
              </Col>
            </Row>

            <!-- iOS -->
            <Row class="row-item" :gutter="12" v-if="!isAndroid">
              <Col span="3" class="col-item">
                <span class="item-field row-item-must">选择已有应用</span>
              </Col>
              <Col span="12">
                <select-app v-if="iOSAppData" :data="iOSAppData" :accounts="accounts" @on-change="changeiOSApp" @on-delete="delApp" />
              </Col>
            </Row>
          </template>
        </template>
        <template v-if="item.href === 'quick_search'">
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <Tooltip placement="top" max-width="300">
                <span class="item-field row-item-must"> 搜索快投 <i class="el-icon-info"></i></span>

                <div slot="content">
                  <p>快速投放到搜索流量，并可以主动添加关键词，设置人群探索</p>
                </div>
              </Tooltip>
            </Col>
            <Col span="12">
              <i-switch style="margin-top: 5px" :true-value="1" :false-value="0" v-model="plan.quick_search"></i-switch>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12" v-if="plan.quick_search">
            <Col span="3" class="col-item">
              <Tooltip placement="top" max-width="300">
                <span class="item-field row-item-must"> 搜索人群探索 <i class="el-icon-info"></i></span>

                <div slot="content">
                  <p>系统将基于用户搜索行为探索定向人群以外的更多优质人群</p>
                </div>
              </Tooltip>
            </Col>
            <Col span="12">
              <i-switch style="margin-top: 5px" :true-value="1" :false-value="0" v-model="plan.target_explore"></i-switch>
            </Col>
          </Row>
        </template>

        <!-- 定向 -->
        <div v-if="item.href === 'plan_client'" style="position: relative">
          <!-- 定向头部切换 -->
          <select-target
            ref="selectTarget"
            :data="targetPlan"
            :media="media"
            :adder="adder"
            :delivery-type="deliveryMethod"
            :open-id="opId"
            :orign-data="{ cityData, appData: originAppData, behaviorAndInterest }"
            @on-current="setTargeter"
            @on-delete="delTargeter"
            @on-select="appendTargeter"
          />

          <!-- 定向内容 -->
          <targeting
            v-if="show"
            :show="show"
            :media="media"
            :target="curTarget"
            :targetName="curName"
            :isUseAdUnion="isUseAdUnion"
            :isAndroid="isAndroid"
            :isIOS="isIOS"
            :isMiniGame="isMiniGame"
            :isLink="isLink"
            @type-change="onTargetTypeChange"
            @on-name="targetNameChange"
          />
        </div>

        <!-- 预算与出价 -->
        <template v-if="item.href === 'plan_price'">
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">计划组预算</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="budget" type="button" @on-change="plan.day_budget = ''">
                <Radio label="NONE" :disabled="plan.speed === 3">不限</Radio>
                <Radio label="BUDGET" :disabled="bidType === 1">日预算</Radio>
              </RadioGroup>
            </Col>
          </Row>
          <Row v-if="budget === 'BUDGET'" class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field row-item-must">&nbsp;</span>
            </Col>
            <Col span="12">
              <Input
                v-model="plan.day_budget"
                placeholder="每日预算范围 100~100,000,000元"
                style="width: 237px"
                @on-blur="inputTrim('day_budget', plan.day_budget, plan, true)"
              >
                <span slot="append" style="padding: 0 6px"> 元 </span>
              </Input>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">投放方式</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="plan.speed" type="button">
                <Radio :label="1">加速投放</Radio>
                <!-- <Radio :label="2" disabled>平滑投放</Radio>
                <Radio :label="3" :disabled="isUseAdUnion || bidType === 1 || true">优先低成本</Radio> -->
              </RadioGroup>
            </Col>
          </Row>

          <!-- 投放时间 -->
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">投放时间</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="dateRange" type="button">
                <Radio label="NONE">从今天起长期投放</Radio>
                <Radio label="RANGE">设置开始和结束日期</Radio>
              </RadioGroup>
            </Col>
          </Row>
          <Row v-if="dateRange === 'RANGE'" class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">&nbsp;</span>
            </Col>
            <Col span="12">
              <Row :gutter="12">
                <Col span="24">
                  <DatePicker
                    type="date"
                    :value="plan.begin_time"
                    placeholder="请选择开始日期"
                    style="width: 160px"
                    :options="{ disabledDate: startOption }"
                    @on-change="changeStartTime"
                  ></DatePicker>
                  <span class="split-line"> —— </span>
                  <DatePicker
                    type="date"
                    :value="plan.end_time"
                    placeholder="请选择结束日期"
                    style="width: 160px"
                    :options="{ disabledDate: endOption }"
                    @on-change="changeEndTime"
                  ></DatePicker>
                </Col>
              </Row>
            </Col>
          </Row>

          <!-- 投放时段 -->
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">投放时段</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="plan.timeRange" type="button" @on-change="radioChange('weektimeData')">
                <Radio label="NONE">不限</Radio>
                <Radio label="RANGE">指定时间段</Radio>
              </RadioGroup>
            </Col>
          </Row>
          <Row v-if="plan.timeRange === 'RANGE'" class="row-item" :gutter="12">
            <Col span="3">&nbsp;</Col>
            <Col span="12">
              <drag-weektime v-model="mult_timeRange" :data="weektimeData" :colspan="1" @on-clear="clearWeektime" />
            </Col>
          </Row>

          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">创意展现方式</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="plan.show_mode" type="button">
                <Radio :label="2">智能优选</Radio>
                <Radio :label="1">随机轮播</Radio>
              </RadioGroup>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12" v-if="plan.promoted_type === 1">
            <Col span="3" class="col-item">
              <span class="item-field">优化目标</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="plan.ocpx_action_type" @on-change="changeConversion" type="button">
                <Radio :label="634">预约表单</Radio>
                <Radio :label="635">预约点击跳转</Radio>
              </RadioGroup>
              <span v-if="batch_task_type === 1 && bidType === 1">
                <span style="color: #ff4400; margin-top: 6px; display: block"
                  >提示：请注意同一个推广计划下面，只能建同一个优化目标类型的计划组，否则建计划会报错。</span
                >
              </span>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12" v-else>
            <Col span="3" class="col-item">
              <span class="item-field">优化目标</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="plan.ocpx_action_type" @on-change="changeConversion" type="button">
                <Radio :label="2">行为数</Radio>
                <Radio :label="180">激活</Radio>
                <Radio :label="190">付费</Radio>
                <Radio :label="739">7日付费次数</Radio>
                <Radio :label="191">首日ROI</Radio>
                <Radio :label="774">7日ROI</Radio>
              </RadioGroup>
              <span v-if="batch_task_type === 1 && bidType === 1">
                <span style="color: #ff4400; margin-top: 6px; display: block"
                  >提示：请注意同一个推广计划下面，只能建同一个优化目标类型的计划组，否则建计划会报错。</span
                >
              </span>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">计费类型</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="plan.bid_type" type="button">
                <Radio :label="10" :disabled="bidType === 1">OCPM</Radio>
                <Radio :label="12" :disabled="bidType === 0">最大转化</Radio>
              </RadioGroup>
            </Col>
          </Row>
          <template v-if="!roiConversion && !bidType">
            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field row-item-must">目标出价</span>
              </Col>
              <Col span="12">
                <RadioGroup v-model="plan.bid_range" type="button" @on-change="changeBidRange">
                  <Radio :label="0">固定金额</Radio>
                  <Radio :label="1">随机金额</Radio>
                </RadioGroup>
              </Col>
            </Row>
            <Row class="row-item" :gutter="12" v-if="plan.bid_range">
              <Col span="3" class="col-item">&nbsp;</Col>
              <Col span="12">
                <input-range v-model="plan.bid_num_range" :precision="2" :min="0.1" :max="10000" placeholder="金额" />
                <span> 元</span>
              </Col>
            </Row>
            <Row class="row-item" :gutter="12" v-else>
              <Col span="3" class="col-item">&nbsp;</Col>
              <Col span="12">
                <Input
                  v-model="plan.cpa_bid"
                  placeholder="请输入出价"
                  style="width: 237px"
                  @on-blur="inputTrim('cpa_bid', plan.cpa_bid, plan, true)"
                >
                  <span slot="append" style="padding: 0 6px"> 元 </span>
                </Input>
              </Col>
            </Row>
          </template>

          <Row class="row-item" :gutter="12" v-show="deepConversion && !bidType">
            <Col span="3" class="col-item">
              <span class="item-field">深度转化目标</span>
            </Col>
            <Col span="12">
              <Select
                v-model="plan.deep_conversion_type"
                placeholder="请选择深度转化目标"
                transfer
                style="width: 358px"
                @on-change="changeDeepConver"
              >
                <Option :value="0" label="无" :disabled="plan.speed === 3" />
                <Option v-for="deep in conversionList" :key="deep.id" :value="deep.id" :label="deep.value" :disabled="plan.speed === 3" />
              </Select>
            </Col>
          </Row>
          <template v-if="conversion">
            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field row-item-must">深度转化目标出价</span>
              </Col>
              <Col span="12">
                <RadioGroup v-model="plan.deep_bid_range" type="button" @on-change="changeDeepCpabidRange">
                  <Radio :label="0">固定金额</Radio>
                  <Radio :label="1">随机金额</Radio>
                </RadioGroup>
              </Col>
            </Row>
            <Row class="row-item" :gutter="12" v-if="plan.deep_bid_range">
              <Col span="3" class="col-item">&nbsp;</Col>
              <Col span="12">
                <input-range v-model="plan.deep_deepbid_num_range" :precision="2" :min="1" :max="10000" placeholder="金额" />
                <span> 元</span>
              </Col>
            </Row>
            <Row class="row-item" :gutter="12" v-else>
              <Col span="3" class="col-item">&nbsp;</Col>
              <Col span="12">
                <Input
                  v-model="plan.deep_conversion_bid"
                  placeholder="出价范围 1~10,000元,须大于目标出价小于组预算"
                  style="width: 237px"
                  @on-blur="inputTrim('deep_conversion_bid', plan.deep_conversion_bid, plan, true)"
                >
                  <span slot="append" style="padding: 0 6px"> 元 </span>
                </Input>
              </Col>
            </Row>
          </template>

          <template v-if="isROI">
            <Row class="row-item" :gutter="12" v-if="!bidType">
              <Col span="3" class="col-item">
                <span class="item-field row-item-must">ROI系数</span>
              </Col>
              <Col span="12">
                <RadioGroup v-model="plan.roi_range" type="button" @on-change="changeRoiRange">
                  <Radio :label="0">固定ROI系数</Radio>
                  <Radio :label="1">随机ROI系数</Radio>
                </RadioGroup>
              </Col>
            </Row>
            <template v-if="!bidType">
              <Row class="row-item" :gutter="12" v-if="plan.roi_range">
                <Col span="3" class="col-item">&nbsp;</Col>
                <Col span="12">
                  <input-range v-model="plan.roi_ratio_range" :precision="3" :min="0.001" :max="100" placeholder="ROI系数" />
                  <span> 元</span>
                </Col>
              </Row>
              <Row class="row-item" :gutter="12" v-else>
                <Col span="3" class="col-item">&nbsp;</Col>
                <Col span="12">
                  <input-number-plus
                    v-model="plan.roi_ratio"
                    :max="3"
                    :min="0.001"
                    :step="0.001"
                    :precision="3"
                    :width="237"
                    placeholder="请输入系数，范围: 0.001 ~ 100 "
                  />
                  <span style="padding: 0 6px"> 元 </span>
                </Col>
              </Row>
            </template>
          </template>
        </template>
      </moduler>
    </div>

    <page-data
      v-model="pageModal"
      :accounts="accounts"
      :filter="false"
      :page-type="plan.union"
      :type="pageType"
      @on-select="selectAccount"
      @on-close="closePage"
    >
    </page-data>

    <landpage v-model="linkModel" @on-select="selectLinkLandPage"></landpage>

    <!-- 提交按钮 -->
    <affix target="c-create-scroll" :offsetBottom="0">
      <div class="c-plan-submit">
        <Row :gutter="12">
          <Col span="12">
            <error-pop v-model="formErr" :state="Boolean(errRes.length)" :data="errRes" @on-close="errRes = []"></error-pop>
          </Col>
          <Col span="12" class="c-btns-submit">
            <Button type="primary" :loading="saving" disabled>
              <span v-if="!saving">上一步</span>
              <span v-else>提交中...</span>
            </Button>
            <Button type="primary" :loading="loading" @click.stop="submitToNext">
              <span v-if="!loading">下一步</span>
              <span v-else>提交中...</span>
            </Button>
          </Col>
        </Row>
      </div>
    </affix>
  </div>
</template>
<script>
import mixin from './mixin'
import target_mixin from './target_mixin'
import conversionData from '@/data/kuaishou/conversion_type.json'
import weektimeData from '@/data/kuaishou/weektime_data'
import { getSession, setSession } from '@/common/js/api'
import {
  isArray,
  isEmpty,
  getTime,
  splicing,
  formatDate,
  clearTagOfData,
  deepCopy,
  pullKeys,
  findCheck,
  getByteLen
} from '@/common/js/utils'
import { getAppList, getPopulationList, getTargetingTags, getBehaviorAndInterest, getAllPagesByAccount } from '@/api/kuaishou.model'
import { getCaoHuaGames, getCaoHuaAgent } from '@/api/common.model'

// import SelectButler from '@/components/select/select-butler.vue'
import SelectMonitor from '@/components/select/select-monitor.vue'
import DragWeektime from '@/components/drag/drag-weektime.vue'
import SelectTarget from '@/components/select/select-target.vue'
import InputRange from '@/components/input/input-number-range'
import PageSelect from '@/components/page-select/page-select.vue'
import PageData from '@/components/page-select/page-data.vue'
import Landpage from '@/components/landpage/landpage.vue'
import SelectApp from './components/selectapp'
import Targeting from './components/targeting'

const now = formatDate(new Date(), 'yyyy-MM-dd')

const innerKeys = [
  'plan_name',
  'ch_platform_id',
  'game_id',
  'landing_type',
  'callback_switch',
  'callback_settings',
  'app_ids',
  'app_name',
  'package',
  'use_sdk',
  'ad_account_id',
  'monitor_template_id',
  'monitor_template_name',
  'plan_auto_task_name',
  'plan_auto_task_id',
  'proxy_account_id',
  'land_page_id',
  'promoted_type'
]

const kuaishouKeys = [
  'union',
  'day_budget',
  'speed',
  'show_mode',
  'begin_time',
  'end_time',
  'schedule_time',
  'ocpx_action_type',
  'bid_type',
  'bid_range',
  'bid_num_range',
  'cpa_bid',
  'deep_conversion_type',
  'deep_bid_range',
  'deep_deepbid_num_range',
  'deep_conversion_bid',
  'scene_id',
  'roi_range',
  'roi_ratio_range',
  'roi_ratio',
  'externalUrls',
  'page_type_custom',
  'quick_search',
  'target_explore',
  'site_id',
  'site_type'
]

export default {
  name: 'ksLocalPlan',
  mixins: [mixin, target_mixin],
  components: { SelectMonitor, DragWeektime, SelectTarget, SelectApp, Targeting, InputRange, PageSelect, PageData, Landpage },
  computed: {
    editState() {
      return this.$route.query.t === 'edit'
    },
    platformGameData() {
      return this.gameData.filter((ret) => ret.ch_platform_id === this.plan.ch_platform_id)
    },
    isAndroid() {
      return this.plan.ch_platform_id === 1
    },
    isIOS() {
      return this.plan.ch_platform_id === 2
    },
    isUseAdUnion() {
      return this.plan.union === 1
    },
    conversionList() {
      // 快手更新 激活显示付费ROI 更名
      // if (this.plan.ocpx_action_type === 180) {
      //   return this.conversionData.filter(ret => ret.id !== 92)
      // } else
      if (this.plan.ocpx_action_type === 190) {
        return this.conversionData.filter((ret) => ret.id !== 3)
      }
      return this.conversionData
    },
    deepConversion() {
      return [180, 190].includes(this.plan.ocpx_action_type)
    },
    roiConversion() {
      return [191, 774].includes(this.plan.ocpx_action_type)
    },
    isROI() {
      return this.roiConversion || this.plan.deep_conversion_type === 92
    },
    startOption() {
      return (date) => {
        return date && (date.valueOf() < Date.now() - 86400000 || date.valueOf() > getTime(this.plan.end_time))
      }
    },
    endOption() {
      return (date) => {
        return date && date.valueOf() < getTime(this.plan.begin_time)
      }
    },
    mult_timeRange() {
      const arr = []
      this.weektimeData.forEach((item) => {
        arr.push({
          id: item.row,
          week: item.value,
          value: splicing(item.child)
        })
      })
      return arr
    },
    adder() {
      return this.targetPlan.length < 50
    },
    curTarget() {
      const { targetingParam } = this.targetPlan.filter((ret) => ret.check).pop() || {}
      return targetingParam
    },
    curName() {
      const { targetingName } = this.targetPlan.filter((ret) => ret.check).pop() || {}
      return targetingName || ''
    },
    isLink() {
      return this.campaign_type === 5
    },
    isMiniGame() {
      return this.campaign_type === 32
    },
    accountId() {
      return getSession('ad_account_ids') ? getSession('ad_account_ids').shift().id : 3602
    },
    pageType() {
      return this.plan.page_type_custom === 1 ? 'kuaishou' : 'ptg'
    }
  },
  watch: {
    isAndroid(val) {
      // iOS游戏自动开启回调开关并禁止关闭
      // const callbackSettings = ['callbackTypeActive', 'callbackTypeRegist', 'callbackTypeRecharge', 'callbackTypeMoney']
      this.$set(this.plan, 'use_sdk', val ? 1 : 0)
      this.$set(this.plan, 'callback_switch', !val ? 1 : 0)
      // !val && this.$set(this.plan, 'callback_settings', callbackSettings)
    },
    isUseAdUnion() {
      this.$set(this.plan, 'speed', 1)
    },
    'plan.speed': {
      handler(val) {
        if (val === 3) {
          this.$set(this, 'budget', 'BUDGET')
          this.$set(this.plan, 'deep_conversion_type', 0)
          this.$set(this, 'conversion', false)
        }
      },
      deep: true
    },
    'plan.ch_platform_id': {
      handler(val) {
        this.targetPlan.forEach((ret) => {
          this.$set(ret.targetingParam, 'platform_os', val === 3 ? 0 : val)
        })
      },
      deep: true
    },
    weektimeData: {
      handler(nVal) {
        if (isArray(nVal)) {
          this.plan.schedule_time = nVal
            .map((item) => {
              return item.child.map((ret) => (ret.check ? '1' : '0')).join('')
            })
            .join('')
        }
      },
      deep: true
    }
  },
  data() {
    return {
      campaign_type: null, // 推广目的
      deliveryMethod: 1, // 1：常规投放；2：智能操盘，3：全自动投放
      targetPlan: [], // 定向列表
      gameData: [], // 常用游戏数据源
      agentData: [], // 人员数据源
      iOSAppData: [],
      appAndList: [],
      landPageList: [],
      weektimeData,
      conversionData,
      budget: 'NONE',
      dateRange: 'NONE', // 投放时间
      conversion: false,
      bidType: null, // 投放场景
      batch_task_type: null, // 1：一对多，2：一对一
      pageModal: false, // 落地页弹框
      linkModel: false,
      plan: {
        // 基础信息
        ad_id: this.$route.query.ad, // 计划ID
        plan_name: '', // 广告计划名称
        ch_platform_id: 1, // 游戏类型
        agent: 'NOAGENT', // 是否代投
        game_id: '',
        proxy_account_id: undefined,
        landing_type: 'APP', // 投放方式—直接下载
        callback_switch: 0, // 回调开关，默认关闭
        callback_settings: ['callbackTypeActive', 'callbackTypeRegist', 'callbackTypeRecharge', 'callbackTypeMoney'], // 回调类型
        managePlan: [], // 计划管家
        monitor_template_id: undefined,
        monitorPlan: [], // 自动化规则
        plan_auto_task_id: undefined,
        land_page_id: null,

        // 投放目标
        union: 0, // 场景Id
        site_id: '', // 预约落地页： 建站ID/下载中间页ID
        promoted_type: 0, // 0 常规落地页， 1预约投放
        site_type: 1, // 投放类型
        page_type_custom: 1, // 推广落地页
        externalUrls: [],
        app_id: 1,
        app_ids: [{}], // 多账号app_id对象
        app_type: 'android',
        app_name: '',
        app_icon: '',
        package: '', // 游戏包名
        download_url: '',
        use_sdk: 1, // 是否接入快手SDK

        // 搜索快投
        quick_search: 0,
        target_explore: 0,

        // 预算与出价
        day_budget: 0, // 预算值
        speed: 1, // 投放方式
        begin_time: now,
        end_time: now,
        timeRange: 'NONE',
        show_mode: 2, // 创意展现方式
        ocpx_action_type: 2, // 优化目标
        bid_type: 10, // 计费类型
        bid_range: 0, // 随机出价
        bid_num_range: ['', ''],
        cpa_bid: '', // 目标转化出价
        deep_conversion_type: 0, // 深度转化目标
        deep_bid_range: 0,
        deep_deepbid_num_range: ['', ''],
        deep_conversion_bid: '', // 深度优化目标出价
        roi_range: 0, // 随机ROI
        roi_ratio_range: [],
        roi_ratio: '' // ROI系数
      }
    }
  },
  methods: {
    preloadData() {
      const account_id = this.accounts[0].id
      // 请求开始
      this.show = false
      this.$Spin.show()
      Promise.all([
        getCaoHuaGames(),
        getCaoHuaAgent(),
        getAppList({ ad_account_id: account_id }),
        getPopulationList({ ad_account_id: account_id }),
        getTargetingTags({ ad_account_id: this.accountId, type: 'APP_INTEREST_ID' }),
        getBehaviorAndInterest({ ad_account_id: account_id }),
        getAllPagesByAccount({ ad_account_id: account_id })
      ])
        .then((data) => {
          const [gameData, agentData, appData, audienceData, appInterest, behaviorAndInterest, allPages] = data

          this.landPageList = allPages

          this.batch_task_type = Number(getSession('batch_task_type'))
          this.campaign_type = Number(getSession('campaign_type'))
          if (this.campaign_type === 32) {
            this.plan.ch_platform_id = 3
            this.plan.landing_type = 'LINK'
            this.plan.site_type = 0
          }
          this.deliveryMethod = Number(getSession('deliveryMethod'))
          if (this.batch_task_type === 1) {
            this.bidType = getSession('bid_type').bid_type
          } else {
            this.bidType = Number(getSession('campaign_params').bid_type)
          }
          if (this.bidType) this.plan.bid_type = 12
          if (this.isLink) {
            this.$set(this.plan, 'landing_type', 'LINK')
          }

          isArray(gameData) && (this.gameData = gameData)
          isArray(agentData) && (this.agentData = agentData)
          if (isArray(audienceData)) {
            this.audiences[0].account_id = account_id
            this.audiences[0].audienceData = audienceData.map((ret) => {
              return {
                id: ret.orientation_id,
                key: ret.orientation_id,
                vaule: ret.orientation_name,
                name: ret.orientation_name,
                extend: ret.cover_num,
                type: ret.population_type,
                code: ret.third_platform_code
              }
            })
          }
          if (isArray(appData) && appData.length) {
            // this.appAndList = appData.filter((ret) => ret.platform === 1)
            this.plan.app_ids[0].account_id = account_id
            this.plan.app_ids[0].iOSAppData = appData.filter((ret) => ret.platform === 'ios')
            this.iOSAppData = this.plan.app_ids[0].iOSAppData
          }
          this.accounts.forEach((ret, idx) => {
            if (idx > 0) {
              this.audiences.push({ account_id: ret.id })
              this.plan.app_ids.push({ account_id: ret.id })
            }
          })
          this.appData = isArray(appInterest) ? appInterest.map((app) => ({ ...app, value: app.name })) : []

          if (behaviorAndInterest) {
            const mapCategroy = (ret) => {
              const cate = {
                id: ret.id,
                value: ret.name
              }
              if (ret.children) {
                return Object.assign({}, cate, {
                  children: ret.children.map(mapCategroy)
                })
              } else {
                return cate
              }
            }
            const { behavior, interest } = behaviorAndInterest
            this.behaviorAndInterest = { behavior: behavior.map(mapCategroy), interest: interest.map(mapCategroy) }
          }
          this.appendTargeter()
          if (!this.isLink) {
            this.targetPlan.forEach((ret) => {
              this.$set(ret.targetingParam, 'platform_os', this.plan.ch_platform_id)
            })
          }
          this.$Spin.hide()
        })
        .catch((e) => {
          console.log('eeeeeeee output: ', e)
          this.show = true
          this.$Spin.hide()
          throw new Error('请求接口错误')
        })
    },
    selectAccount(val) {
      this.plan.externalUrls = val
      this.pageModal = false
    },
    closePage() {
      this.pageModal = false
    },
    changeUnion() {
      this.plan.externalUrls = []
    },
    selectLinkLandPage(meta) {
      this.plan.land_page_id = meta.land_page_id
      this.linkModel = false
    },
    platformChange(val) {
      this.plan.game_id = ''
      this.plan.app_icon = ''
      this.plan.package = ''
      this.plan.download_url = '' // 包下载地址

      // 小程序平台不能预约投放，切换到常规落地页
      if (val === 3) {
        this.plan.promoted_type = 0
      }

      // 安卓游戏名称填入应用名称
      if (this.isAndroid) this.$set(this.plan, 'app_name', '')
      this.plan.app_ids.map((ret) => {
        if (isArray(ret.iOSAppData)) {
          ret.iOSAppData.map((met) => {
            this.$set(met, 'select', '')
          })
        }
      })
      if (this.isLink) {
        // this.$set(this.plan, 'site_type', 0)
      } else {
        this.targetPlan.forEach((ret) => {
          this.$set(ret.targetingParam, 'platform_os', this.plan.ch_platform_id)
        })
      }
    },
    handleGame(meta) {
      this.plan.game_id = meta.id
      this.plan.app_icon = meta.icon
      this.plan.package = meta.ad_package // 更改成显示包名
      this.plan.download_url = meta.game_address // 包下载地址
      // 安卓游戏名称填入应用名称
      if (this.isAndroid) {
        this.$set(this.plan, 'app_name', meta.name)
        if (isArray(meta.sdks) && meta.sdks.includes('2005')) {
          this.plan.callback_switch = 0
          this.plan.use_sdk = 1
        } else {
          this.plan.callback_switch = 1
          this.plan.use_sdk = 0
        }
      }
    },
    // 代投账号
    changeAgent(val) {
      if (val === 'AGENT') this.plan.proxy_account_id = ''
      else this.plan.proxy_account_id = undefined
    },
    // 选择代投账号
    handleAgent(meta) {
      this.plan.proxy_account_id = meta.id
    },
    // 选择计划管家回调
    appendButler(val) {
      this.plan.managePlan = val
    },
    // 删除自动化规则
    delMonitor(id) {
      const index = this.plan.managePlan.findIndex((ret) => ret.id === id)
      if (index > -1) this.plan.managePlan.splice(index, 1)
    },

    // 切换投放类型时，优化目标对应也需要切换
    onPromotedChange(e) {
      if (e === 1) {
        // 预约投放
        this.plan.ocpx_action_type = 634
      } else {
        // 常规投放
        this.plan.ocpx_action_type = 2
      }
    },
    changeConversion() {
      if (this.isROI) this.plan.cpa_bid = 0
      else this.plan.roi_ratio = undefined
      if (!this.deepConversion) {
        this.plan.deep_conversion_type = 0
        this.plan.deep_conversion_bid = undefined
        this.conversion = false
      }
    },
    changeiOSApp({ id, index, iOSAppData }) {
      if (!isArray(this.plan.app_ids[index].iOSAppData)) {
        this.plan.app_ids[index].account_id = id
        this.plan.app_ids[index].iOSAppData = iOSAppData
        this.iOSAppData = iOSAppData
      } else this.iOSAppData = this.plan.app_ids[index].iOSAppData
    },
    delApp({ list, name }) {
      const index = list.findIndex((ret) => ret.name === name)
      if (index > -1) {
        this.$set(list[index], 'select', '')
      }
    },
    // 投放时间
    changeStartTime(val) {
      const start = getTime(val)
      const end = getTime(this.plan.end_time)
      if (end < start) this.plan.end_time = val
      this.plan.begin_time = val
    },
    changeEndTime(val) {
      this.plan.end_time = val
    },
    changeDeepConver(val) {
      this.conversion = val === 3
      if (val === 3) {
        this.plan.deep_conversion_bid = ''
      } else {
        this.plan.deep_conversion_bid = undefined
      }
    },
    // 切换随机出价
    changeBidRange(val) {
      if (val) {
        this.$set(this.plan, 'bid_num_range', ['', ''])
        this.$set(this.plan, 'cpa_bid', '')
      }
    },
    changeDeepCpabidRange(val) {
      if (val) {
        this.$set(this.plan, 'deep_deepbid_num_range', ['', ''])
        this.$set(this.plan, 'deep_conversion_bid', '')
      }
    },
    radioChange(key) {
      clearTagOfData(this[key], this)
    },
    // 清空时间段
    clearWeektime() {
      this.weektimeData.forEach((item) => {
        item.child.forEach((t) => {
          this.$set(t, 'check', false)
        })
      })
    },
    submitToNext() {
      const params = this.checkParams()
      // 验证模板
      if (!params) return
      if (this.errRes.length) return
      // 保存并修改
      setSession('ks_batch_second_params', this.$data)
      setSession('inner_plan_params', params.inner_plan_params)
      setSession('outer_plan_params', params.outer_plan_params)
      setSession('targetings', params.targetings)
      if (this.editState) this.$router.push({ name: 'kuaishoulocalidea', query: { t: 'edit' } })
      else this.$router.push({ name: 'kuaishoulocalidea' })
    },

    onTargetTypeChange(type) {
      if (type === 1) {
        const currPlanIdx = this.targetPlan.findIndex((ret) => ret.check)
        const currTarget = this.targetPlan[currPlanIdx]
        const audiences = currTarget.targetingParam.audiences[0]
        audiences.audienceData = audiences.audienceData.map((au) => {
          return { ...au, select: null }
        })
        this.targetPlan.splice(currPlanIdx, 1, {
          ...currTarget,
          targetingParam: {
            audienceData: audiences.audienceData,
            ...currTarget.targetingParam,
            audiences: [audiences]
          }
        })
      }
    },
    checkParams() {
      const regexp = /({[\u4e00-\u9fa5]{2,}})/g
      let params = { ad_account_id: this.account }
      params = Object.assign({}, deepCopy(this.plan), params)

      this.errRes = this.valid() // 表单验证

      if (!isEmpty(params.plan_name)) {
        const values = params.plan_name.match(regexp)
        let plan_name_length = getByteLen(params.plan_name)
        if (isArray(values)) {
          values.forEach((ret) => {
            ret === '{定向包名}' && (plan_name_length += 11)
            ret === '{创意组名}' && (plan_name_length += 11)
          })
        }
        if (plan_name_length > 80) this.errRes.push({ feild: '计划名称', msg: `加入动态词后的长度${plan_name_length}，超过了80个字符` })
      }
      if (this.check === 'error') this.errRes.push({ feild: '计划名称', msg: '已存在，请更换成可用名称' }) // 定向名重复
      if (this.dateRange !== 'RANGE') params.end_time = ''

      if (!this.roiConversion && !this.bidType) {
        const { cpa_bid, day_budget, bid_range, bid_num_range } = params
        const behaviorBid = this.plan.ocpx_action_type === 2 // 行为数出价限制
        const maxBid = behaviorBid ? 10 : 10000
        const minBid = behaviorBid ? 0.1 : 1
        if (bid_range) {
          // 随机出价
          const [min, max] = bid_num_range
          if (isEmpty(min) || isEmpty(max)) this.errRes.push({ feild: '目标转化出价', msg: '随机值不能为空' })
          else if (day_budget && Math.max(min, max) > day_budget) {
            this.errRes.push({ feild: '目标转化出价', msg: `随机值不能大于预算值 ${day_budget}` })
          } else if (Math.max(min, max) > maxBid || Math.min(min, max) < minBid) {
            this.errRes.push({ feild: '目标转化出价', msg: `出价范围: ${minBid}~${maxBid} 元` })
          }
        } else {
          if (isEmpty(cpa_bid)) this.errRes.push({ feild: '目标转化出价', msg: '目标转化出价不能为空' })
          else if (cpa_bid < minBid || cpa_bid > maxBid) {
            this.errRes.push({ feild: '目标转化出价', msg: `出价范围: ${minBid}~${maxBid} 元` })
          } else if (day_budget && cpa_bid && cpa_bid > day_budget) {
            this.errRes.push({ feild: '目标转化出价', msg: `出价不能大于预算值 ${day_budget}` })
          }
        }
      }
      if (this.isROI && !this.bidType) {
        const { roi_range, roi_ratio_range, roi_ratio } = params
        if (roi_range) {
          // 随机出价
          const [min, max] = roi_ratio_range
          if (isEmpty(min) || isEmpty(max)) this.errRes.push({ feild: 'ROI系数', msg: '随机值不能为空' })
        } else {
          if (isEmpty(roi_ratio)) this.errRes.push({ feild: 'ROI系数', msg: '系数不能为空' })
          else if (roi_ratio <= 0.001 || roi_ratio > 100) this.errRes.push({ feild: 'ROI系数', msg: '系数范围: 0.001 ~ 100' })
        }
      }
      if (this.conversion) {
        const { day_budget, cpa_bid, bid_range, bid_num_range, deep_conversion_bid, deep_bid_range, deep_deepbid_num_range } = params
        const [cmin, cmax] = bid_num_range
        if (deep_bid_range) {
          const [min, max] = deep_deepbid_num_range
          if (isEmpty(min) || isEmpty(max)) this.errRes.push({ feild: '深度转化出价', msg: '随机值不能为空' })
          else if (cpa_bid && Math.min(min, max) <= cpa_bid) this.errRes.push({ feild: '深度转化出价', msg: '随机值应大于目标转化出价' })
          else if (bid_range && Math.max(cmin, cmax) > Math.min(min, max)) {
            this.errRes.push({ feild: '深度转化出价', msg: '随机值应大于目标转化出价' })
          } else if (day_budget && day_budget < Math.max(min, max)) {
            this.errRes.push({ feild: '深度转化出价', msg: `随机值应小于预算值 ${day_budget}` })
          }
        } else {
          if (isEmpty(deep_conversion_bid)) this.errRes.push({ feild: '深度转化出价', msg: '出价不能为空' })
          else if (deep_conversion_bid <= 1 || deep_conversion_bid > 10000) {
            this.errRes.push({ feild: '深度转化出价', msg: '出价范围：1~10000（元）' })
          } else if (cpa_bid && cpa_bid >= deep_conversion_bid) {
            this.errRes.push({ feild: '深度转化出价', msg: '深度转化出价应大于目标转化出价' })
          } else if (bid_range && Math.max(cmin, cmax) > deep_conversion_bid) {
            this.errRes.push({ feild: '深度转化出价', msg: '深度转化出价应大于目标转化出价' })
          } else if (day_budget && day_budget < deep_conversion_bid) {
            this.errRes.push({ feild: '深度转化出价', msg: `深度转化出价应小于预算值 ${day_budget}` })
          }
        }
      }

      if (this.isIOS) {
        params.app_ids.map((ret, idx) => {
          const { iOSAppData } = ret
          const app = isArray(iOSAppData) ? iOSAppData.filter((ret) => ret.select) : undefined
          if (!app || !app.length) {
            this.errRes.push({ feild: 'iOS应用', msg: `第${idx + 1}个账号请选择iOS应用` })
          } else {
            const [appinfo] = app

            this.$set(ret, 'app_id', appinfo.app_id)
            this.$set(ret, 'package_id', appinfo.package_id)
            this.$set(ret, 'real_app_name', appinfo.real_app_name)
            // delete ret.iOSAppData // 删除数据源
          }
        })
      }

      if (this.isMiniGame) {
        const { externalUrls, page_type_custom } = this.plan
        if (page_type_custom === 1 && !externalUrls.length) {
          this.errRes.push({ feild: '快手建站落地页', msg: '快手建站落地页不能为空' })
        }
      }

      if (this.isLink) {
        const { promoted_type, page_type_custom, externalUrls, land_page_id, site_id } = this.plan
        // 常规落地页
        if (promoted_type === 0) {
          if (page_type_custom === 1 && !externalUrls.length) {
            this.errRes.push({ feild: '快手建站落地页', msg: '快手建站落地页不能为空' })
          }
          if (page_type_custom === 2 && !land_page_id) {
            this.errRes.push({ feild: '平头哥落地页', msg: '平头哥落地页不能为空' })
          }
        }

        // 预约落地页
        if (promoted_type === 1) {
          if (!site_id) {
            this.errRes.push({ feild: '预约落地页', msg: '请选择预约落地页' })
          }
        }
      }

      // 定向参数处理
      const targetNames = []
      const targets = deepCopy(this.targetPlan).map((ret, idx) => {
        const { targetingParam: target, targetingName } = ret
        if (!targetingName) {
          this.errRes.push({ feild: '定向包名', msg: `第${idx + 1}个定向包名不可为空` })
        }
        const isExists = targetNames.includes(targetingName.trim())
        if (isExists) {
          this.errRes.push({ feild: '定向包名', msg: `第${idx + 1}个定向包名重复` })
        }
        if (isEmpty(ret.targetingParam.platform_os)) this.errRes.push({ feild: '操作系统版本', msg: `第${idx + 1}个操作系统版本不能为空` })
        targetNames.push(targetingName.trim())
        if (target.ageMode === 'CUSTOM') {
          target.age = { min: target.age[0], max: target.age[1] }
        } else target.age = null
        if (!target.device_brand_ids) target.device_brand_ids = []
        if (!target.device_price) target.device_price = []
        if (target.app_behavior === 1) delete target.app_ids
        else if (target.app_behavior === 2) delete target.app_interest_ids
        if (target.platform_os === 1) delete target.ios_osv
        else if (target.platform_os === 2) {
          delete target.android_osv
          delete target.device_brand_ids
        }

        // 人群包提交
        target.audiences.map((met) => {
          let dataSource = met.audienceData
          dataSource = dataSource && isArray(dataSource) ? dataSource : []
          const payType = (type) => this.payTypeBag.includes(type)
          met.population = dataSource.filter((ret) => ret.select === 'include' && !payType(ret.type)).map((t) => t.id)
          met.exclude_population = dataSource.filter((ret) => ret.select === 'exclude' && !payType(ret.type)).map((t) => t.id)
          met.paid_audience = dataSource.filter((ret) => ret.select === 'include' && payType(ret.type)).map((t) => t.id)
        })
        // 行为兴趣定向
        if (target.behavior_type === 1) {
          const keyword = target.action_tags
            .filter((ret) => ret.type === 'KEYWORD')
            .map((ret) => {
              return {
                id: ret.id,
                name: ret.name
              }
            })
          const action_label = target.action_tags.filter((ret) => ret.type === 'CATEGORY').map((ret) => ret.id)
          const interest_label = target.word_tags.filter((ret) => ret.type === 'CATEGORY').map((ret) => ret.id)
          if (keyword.length || action_label.length || interest_label.length) {
            target.behavior_interest = {
              behavior: {
                keyword: keyword,
                label: action_label,
                time_type: target.action_days,
                strength_type: target.action_intensity,
                scene_type: target.action_scene
              }
            }

            if (interest_label.length) {
              target.behavior_interest.interest = {
                label: interest_label,
                strength_type: target.interest_intensity
              }
            }
          } else {
            // 如果没有选中任何项，兴趣行为设置为不限
            target.behavior_type = 0
          }
        }

        // 数据源存储参数处理
        this.findDataSourceParams(target)
        this.delDataSource(target)
        return ret
      })
      if (this.errRes.length) {
        this.formErr = true
        return // 如果错误中断
      }
      params.targets = targets
      params.plan_auto_task_id = params.managePlan.map((ret) => ret.id).join(',')
      params.plan_auto_task_name = params.managePlan.map((ret) => ret.name).join(',')
      params.monitor_template_id = params.monitorPlan.map((ret) => ret.id).join(',')
      params.monitor_template_name = params.monitorPlan.map((ret) => ret.ruleName).join(',')

      return this.wrapParams(params)
    },
    wrapParams(params) {
      const targetings = params.targets
      const inner_plan_params = pullKeys(innerKeys, params)
      const outer_plan_params = pullKeys(kuaishouKeys, params)
      outer_plan_params.budget = this.budget
      return {
        inner_plan_params,
        outer_plan_params,
        targetings
      }
    },
    findDataSourceParams(target) {
      const mult_city = findCheck(target.cityData)
      const mult_app = findCheck(target.appData)
      const getId = (ret) => ret.id
      target.region = mult_city.map(getId)
      target.app_interest_ids = mult_app.map((ret) => ret.ids || ret.id).flat(1)
      target.app_ids = target.mult_cate.map(getId)
    },
    delDataSource(target) {
      const delKeys = ['appData', 'audienceData', 'cityData']
      delKeys.forEach((key) => target[key] && delete target[key], delKeys)
      const { audiences } = target
      if (isArray(audiences)) audiences.forEach((ret) => ret.audienceData && delete ret.audienceData)
    },
    valid() {
      const rules = [
        {
          name: 'plan/plan_name',
          require: true,
          min: 3,
          max: 80,
          desc: '计划名称'
        },
        {
          name: 'plan/game_id',
          require: true,
          min: 1,
          desc: '投放游戏'
        },
        {
          name: 'plan/proxy_account_id',
          require: true,
          relyon: 'agent',
          relyvalue: 'AGENT',
          min: 1,
          desc: '代投账号'
        },
        {
          name: 'plan/app_name',
          require: true,
          relyon: 'isAndroid',
          relyvalue: true,
          min: 1,
          desc: '游戏名'
        },
        {
          name: 'plan/day_budget',
          require: true,
          relyon: 'budget',
          relyvalue: 'BUDGET',
          min: 100,
          max: 100000000,
          desc: '预算'
        },
        {
          name: 'plan/schedule_time',
          require: true,
          relyon: 'timeRange',
          relyvalue: 'RANGE',
          desc: '投放时段'
        },
        {
          name: 'plan/begin_time',
          require: true,
          relyon: 'dateRange',
          relyvalue: 'RANGE',
          desc: '开始日期'
        },
        {
          name: 'plan/end_time',
          require: true,
          relyon: 'dateRange',
          relyvalue: 'RANGE',
          desc: '结束日期'
        }
      ]
      this.formErr = false
      return this.invalid(rules)
    }
  },
  created() {
    const data = getSession('ks_batch_second_params') || {}
    if (data && Object.keys(data).length > 0 && this.editState) {
      Object.keys(data).forEach((ret) => {
        this.$set(this, ret, data[ret])
      })
    } else this.preloadData()
  }
}
</script>
<style lang="scss" scoped>
.c-plan {
  height: inherit;

  .m-bread {
    line-height: 20px;
    margin-bottom: 12px;
  }

  .module-content {
    overflow-y: auto;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;

    height: calc(100% - 96px);
  }

  .dynamic-error {
    margin: 0;
  }

  .m-dynamic {
    padding-top: 10px;
    margin: 0;

    li {
      display: inline-block;
      margin-left: 12px;
    }
  }

  .inner-checkbox-mini {
    display: inline-block;
    margin-right: 24px;
  }

  .inner-checkbox {
    display: inline-block;
    width: 180px;
  }

  .c-plan-submit {
    padding: 15px;
    min-width: 1130px;
    background-color: #fff;
    border: 1px solid #eaeaea;
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 #eff1fa;
    position: relative;
    z-index: 98;

    .c-btns-submit {
      text-align: right;

      button {
        margin-left: 8px !important;
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }

  .col-flex {
    min-height: 32px;
    display: flex;
    align-items: center;
  }

  ::v-deep .row-item {
    align-items: flex-start;

    span.item-field {
      height: 32px;
      line-height: 32px;
    }
  }
}

.el-icon-circle-close-outline {
  cursor: pointer;
}

.c-group-desc {
  position: absolute;
  left: 0;
  bottom: -20px;
  color: #ff4400;
}

.c-save-dialog {
  position: relative;

  .m-save-target {
    padding: 22px 0;

    .col-item {
      padding-top: 6px;
    }
  }
}
</style>
